// Driver-side cancel reasons, tailored per shared service.
const VEHICLE = { value: "mechanical", label: "Vehicle / mechanical issue" };
const EMERGENCY = { value: "emergency", label: "Emergency" };
const OTHER = { value: "other", label: "Other" };

const REASONS = {
  ride: [
    { value: "no_show", label: "Rider didn't show up" },
    { value: "wrong_location", label: "Wrong pickup location" },
    { value: "too_many_passengers", label: "Too many passengers or bags" },
    { value: "unsafe", label: "Felt unsafe" },
  ],
  delivery: [
    { value: "no_show", label: "Sender not at pickup" },
    { value: "package_not_ready", label: "Package wasn't ready" },
    { value: "package_too_big", label: "Package too big or heavy" },
    { value: "prohibited_item", label: "Item not allowed" },
    { value: "recipient_unreachable", label: "Can't reach the recipient" },
    { value: "wrong_location", label: "Wrong address" },
  ],
  runner: [
    { value: "item_unavailable", label: "Item or service not available" },
    { value: "not_as_described", label: "Errand isn't as described" },
    { value: "no_show", label: "Customer not reachable" },
    { value: "over_budget", label: "Costs more than agreed" },
    { value: "wrong_location", label: "Wrong address" },
  ],
  van: [
    { value: "no_show", label: "Customer didn't show up" },
    { value: "load_too_big", label: "Load too big for the van" },
    { value: "needs_helpers", label: "Needs more loaders" },
    { value: "no_access", label: "Can't reach the building" },
    { value: "wrong_location", label: "Wrong pickup location" },
  ],
  laundry_from_customer: [
    { value: "no_show", label: "Customer not home" },
    { value: "clothes_not_ready", label: "Clothes weren't ready" },
    { value: "too_many_bags", label: "Too many bags to carry" },
    { value: "wrong_location", label: "Wrong address" },
  ],
  laundry_from_shop: [
    { value: "shop_closed", label: "Laundry shop closed" },
    { value: "order_not_ready", label: "Order not ready at the shop" },
    { value: "shop_refused", label: "Shop wouldn't release the clothes" },
    { value: "recipient_unreachable", label: "Can't reach the customer" },
  ],
  trash: [
    { value: "no_show", label: "Customer not home" },
    { value: "trash_not_ready", label: "Trash wasn't bagged or ready" },
    { value: "too_much_trash", label: "Too much trash for my truck" },
    { value: "hazardous", label: "Hazardous waste" },
    { value: "no_access", label: "Can't reach the location" },
  ],
};

export const serviceKind = (trip) => {
  if (trip?.service_flavor === "trash") return "trash";
  if (trip?.service_flavor === "laundry") return trip?.laundry_direction === "dropoff" ? "laundry_from_shop" : "laundry_from_customer";
  const t = trip?.rideshare_type;
  if (t === "delivery" || t === "runner" || t === "van") return t;
  if (trip?.vehicle_type === "van" || trip?.van_note || trip?.van_voice_note || trip?.van_scheduled_start) return "van";
  return "ride";
};

export const cancelReasonsFor = (trip) => [...REASONS[serviceKind(trip)], VEHICLE, EMERGENCY, OTHER];

const NOUNS = { ride: "ride", delivery: "delivery", runner: "errand", van: "move", laundry_from_customer: "laundry pickup", laundry_from_shop: "laundry delivery", trash: "trash pickup" };
export const cancelNoun = (trip) => NOUNS[serviceKind(trip)];
export const customerNoun = (trip) => (serviceKind(trip) === "ride" ? "rider" : "customer");

// "Accept job" for errand-style services, "Accept trip" for passenger rides.
export const acceptLabel = (trip) => (["ride", "van"].includes(serviceKind(trip)) ? "Accept trip" : "Accept job");
